import React, { useState } from 'react'
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import '../componentCss/webform.css';
import { useNavigate, Link } from "react-router-dom";
import Dashboardheader from './dashboardheader';
import Sidebar from './sidebar';
import '../componentCss/sidebar.css';
import { saveMasterDataAction } from '../../Action/modernAdminActions';
import { useMigrationHelper } from '../../utils/migrationHelper';
import toast from 'react-hot-toast';
import { BsArrowLeftCircleFill, BsFillTrash3Fill } from "react-icons/bs";
import config from '../../config/config';
import { v4 as uuidv4 } from 'uuid';

const Webform = () => {
    const navigate = useNavigate();
    const { useModernAPI } = useMigrationHelper();

    const allowedTypes = [
        "string", "integer", "float", "boolean", "date", "datetime",
        "email", "phone", "url", "select", "multi_select", "text"
    ];

    // Form state
    const [formData, setForm] = useState({
        tableName: '',
        description: '',
        category: '',
        access_level: '',
        allowed_roles: ''
    });

    // Columns array
    const [formValues, setFormValues] = useState([
        {
            name: "",
            data_type: "string",
            required: false,
            unique: false,
            default_value: "",
            max_length: 0,
            min_length: 0,
            min_value: 0,
            max_value: 0,
            options: "",
            description: "",
            order: 0
        }
    ]);

    const [rowIndex, setRowIndex] = useState(0);

    // Handle changes for table-level fields
    const handleChangeForm = (e) => {
        const { name, value } = e.target;
        setForm((old) => ({
            ...old,
            [name]: value
        }));
    };

    // Handle input change for column fields
    // const handleChange = (i, e) => {
    //     const { name, value } = e.target;

    //     // Validation for first char of name fields
    //     if (name === "name" && value !== "" && !isFirstCharacterNotNumber(value)) {
    //         toast.error("First character of field name should not be a number.");
    //         return;
    //     }

    //     let newFormValues = [...formValues];
    //     newFormValues[i][name] = value;
    //     setFormValues(newFormValues);
    // };

    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.name] = e.target.value;
        setFormValues(newFormValues);
    };

    // Handle checkbox change
    const handleCheckboxChange = (i, e) => {
        const { name, checked } = e.target;
        let newFormValues = [...formValues];
        newFormValues[i][name] = checked;
        setFormValues(newFormValues);
    };

    // Add new column row
    const addFormFields = () => {
        setFormValues([...formValues, {
            name: "",
            data_type: "",
            required: false,
            unique: false,
            default_value: "",
            max_length: 0,
            min_length: 0,
            min_value: 0,
            max_value: 0,
            options: "",
            description: "",
            order: 0
        }]);
        setRowIndex(rowIndex + 1);
    };

    // Remove column row
    const removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues);
        setRowIndex(rowIndex - 1);
    };

    // First character must not be a number
    function isFirstCharacterNotNumber(str) {
        return isNaN(str.charAt(0));
    }

    // Submit form
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formData.tableName) {
            toast.error("Table name required.");
            return;
        }

        if (!isFirstCharacterNotNumber(formData.tableName)) {
            toast.error("First character of table name should not be a number.");
            return;
        }

        // Check required fields for each column
        let missing = formValues.some(
            field => !field.name || !field.data_type
        );

        if (missing) {
            toast.error("All fields are required.");
            return;
        }

        const payload = {
            table_id: uuidv4(), //generate UUID if required
            name: formData.tableName,
            description: formData.description,
            category: formData.category,
            columns: formValues.map((field, idx) => ({
                column_id: "",
                name: field.name,
                data_type: field.data_type,
                required: field.required,
                unique: field.unique,
                default_value: field.default_value || null,
                max_length: Math.max(1, Number(field.max_length) || 1),
                min_length: Number(field.min_length) || 0,
                min_value: Number(field.min_value) || 0,
                max_value: Number(field.max_value) || 0,
                options: field.options
                    ? field.options.split(",").map((s) => s.trim())
                    : [],
                description: field.description,
                order: idx + 1
            })),
            access_level: formData.access_level || "public",
            allowed_roles: formData.allowed_roles
                ? formData.allowed_roles.split(",").map((s) => s.trim())
                : []
        };

        try {
            let res;
            if (useModernAPI) {
                res = await saveMasterDataAction(payload);
            } else {
                const { saveMasterDataAction: legacySaveMasterDataAction } = await import('../../Action/admin.action');
                res = await legacySaveMasterDataAction(payload);
            }

            if (res.success) {
                toast.success(res.message || res.msg);
                setTimeout(() => {
                    navigate(`${config.baseUrl}master-data`);
                }, 2000);
            } else {
                toast.error(res.message || res.msg);
            }
        } catch (error) {
            toast.error('Failed to save master data');
        }
    };

    return (
        <>
            <Dashboardheader />
            <div className="wrapper">
                <Sidebar />
                <div id="content">
                    <Container fluid className="p-4">
                        <Row>
                            <Col lg={12} md={12} sm={12}>
                                <div className="innerhead mb-4">
                                    <h5 className='headtitle'>Add New Master Table</h5>
                                </div>
                                <Link to={`${config.baseUrl}master-data`} >
                                    <span style={{ float: 'right' }}>Back <BsArrowLeftCircleFill /></span>
                                </Link>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12} md={12} sm={12}>
                                <div className='formDiv'>
                                    <Form>
                                        <Row className="mb-4">
                                            <Form.Group as={Col}>
                                                <Form.Label>Table Name</Form.Label>
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name='tableName'
                                                    value={formData.tableName}
                                                    onChange={handleChangeForm}
                                                    placeholder="Enter table name"
                                                />
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-4">
                                            <Form.Group as={Col}>
                                                <Form.Label>Description</Form.Label>
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name='description'
                                                    value={formData.description}
                                                    onChange={handleChangeForm}
                                                    placeholder="Enter description"
                                                />
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-4">
                                            <Form.Group as={Col}>
                                                <Form.Label>Category</Form.Label>
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name='category'
                                                    value={formData.category}
                                                    onChange={handleChangeForm}
                                                    placeholder="Enter category"
                                                />
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-4">
                                            <Form.Group as={Col}>
                                                <Form.Label>Access Level</Form.Label>
                                                <select
                                                    className='form-control'
                                                    name='access_level'
                                                    value={formData.access_level}
                                                    onChange={handleChangeForm}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="public">Public</option>
                                                    <option value="private">Private</option>
                                                </select>
                                            </Form.Group>
                                        </Row>

                                        <Row className="mb-4">
                                            <Form.Group as={Col}>
                                                <Form.Label>Allowed Roles (comma separated)</Form.Label>
                                                <input
                                                    className='form-control'
                                                    type="text"
                                                    name='allowed_roles'
                                                    value={formData.allowed_roles}
                                                    onChange={handleChangeForm}
                                                    placeholder="e.g. admin, editor"
                                                />
                                            </Form.Group>
                                        </Row>
                                    </Form>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12} md={12} sm={12}>
                                <div className='maintable table-responsive'>
                                    <h5>Master Table Fields</h5>
                                    <form onSubmit={handleSubmit} className='mt-4'>
                                        {formValues.map((element, index) => (
                                            <div className="form-inline mt-2" key={index}>
                                                <div className='row g-3'>
                                                    <div className='col-md-1'>
                                                        {index === 0 && <span>No.</span>}
                                                        <label>{index + 1}</label>
                                                    </div>

                                                    <div className='col-md-2'>
                                                        {index === 0 && <span>Field Name</span>}
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="name"
                                                            value={element.name || ""}
                                                            placeholder="Field Name"
                                                            onChange={e => handleChange(index, e)}
                                                        />
                                                    </div>

                                                    <div className='col-md-2'>
                                                        {index === 0 && <span>Data Type</span>}
                                                        <select
                                                            className="form-control"
                                                            name="data_type"
                                                            value={element.data_type}
                                                            onChange={e => handleChange(index, e)}
                                                        >
                                                            {allowedTypes.map((type) => (
                                                                <option key={type} value={type}>{type}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className='col-md-1 d-flex align-items-center'>
                                                        <input
                                                            type="checkbox"
                                                            name="required"
                                                            checked={element.required}
                                                            onChange={e => handleCheckboxChange(index, e)}
                                                        /> <span className='ms-2'>Required</span>
                                                    </div>

                                                    <div className='col-md-1 d-flex align-items-center'>
                                                        <input
                                                            type="checkbox"
                                                            name="unique"
                                                            checked={element.unique}
                                                            onChange={e => handleCheckboxChange(index, e)}
                                                        /> <span className='ms-2'>Unique</span>
                                                    </div>

                                                    <div className='col-md-2'>
                                                        {index === 0 && <span>Default Value</span>}
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="default_value"
                                                            value={element.default_value || ""}
                                                            onChange={e => handleChange(index, e)}
                                                        />
                                                    </div>

                                                    <div className='col-md-2'>
                                                        {index === 0 && <span>Description</span>}
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="description"
                                                            value={element.description || ""}
                                                            onChange={e => handleChange(index, e)}
                                                        />
                                                    </div>

                                                    <div className='col-md-1 d-flex align-items-center'>
                                                        {index > 0 &&
                                                            <BsFillTrash3Fill onClick={() => removeFormFields(index)} style={{ cursor: 'pointer' }} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        <br />
                                        <div className="button-section">
                                            <Button variant="secondary-btn3" onClick={addFormFields} className='px-3 py-2 btn-sm btn-secondary-btn3 fs-6'>Add field</Button> &nbsp;&nbsp;&nbsp;&nbsp;
                                            <Button variant="secondary-btn3" type='submit' className='px-3 py-2 btn-sm btn-secondary-btn3 fs-6'>Submit</Button>
                                        </div>
                                    </form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default Webform;
